/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%}.question-configuration-container[_ngcontent-%COMP%]{margin:0;padding:0}.questions-container[_ngcontent-%COMP%]{padding:2em;border-bottom:1px solid #d9d9d9;overflow-y:auto}  #outer-info{width:100%}  #inner-info{display:table;margin:200px auto}"];
export { styles as styles };
